import type { UseMyAccountPage } from '~~/types/myaccount/UseMyAccountPage';
import { ROUTES } from '~~/constants/routes';

export const useLogoutPage = (route = ROUTES.LOG_OUT, translationKey = 'Log out'): ReturnType<UseMyAccountPage> => {

  const page = useAccountInternalPage(route, translationKey, 'iconify fa-pro-light--right-from-bracket');
  const isInternal = false;

  return {
    ...page,
    isInternal,
  };

};
